/**
 * Downloads a file from an authenticated endpoint (spare parts, Push 2: the
 * Settings → Spare parts export).
 *
 * A plain <a href> cannot carry the Authorization header, so this fetches
 * through authFetch, turns the answer into a Blob and clicks a temporary
 * <a download>, as downloadCsv.js does. It never throws: the caller shows
 * the message.
 */
export const DOWNLOAD_FAILED_MESSAGE = 'The file could not be downloaded.';

/**
 * @param {Function} authFetch
 * @param {string} url - e.g. '/api/v1/parts/catalogue/export'
 * @param {string} fileName - what the browser saves it as
 * @returns {Promise<{ ok: boolean, message: string|null }>} message is the
 *          answer's JSON message, or DOWNLOAD_FAILED_MESSAGE
 */
export async function downloadFile(authFetch, url, fileName) {
  let response;
  try {
    response = await authFetch(url);
  } catch (error) {
    return { ok: false, message: DOWNLOAD_FAILED_MESSAGE };
  }
  if (!response || !response.ok) {
    let message = DOWNLOAD_FAILED_MESSAGE;
    try {
      const body = await response.json();
      if (body && typeof body.message === 'string' && body.message) message = body.message;
    } catch (error) { /* not JSON: keep the plain sentence */ }
    return { ok: false, message };
  }
  try {
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
    return { ok: true, message: null };
  } catch (error) {
    return { ok: false, message: DOWNLOAD_FAILED_MESSAGE };
  }
}

export default downloadFile;
